/* [04] FCFS EVERYWHERE / Preview only.
   Opt in with ?bf04=1 or ?fcfs04=1. Never modifies Shopify prices/checkout. */
(()=>{'use strict';
const qp=new URLSearchParams(location.search);
const store=(()=>{try{return window.sessionStorage}catch{return null}})();
const key='bf04_fcfs_demo',startKey='bf04_fcfs_start';
const on=qp.get('bf04')==='1'||qp.get('fcfs04')==='1';
if(qp.get('fcfs04')==='0'){
 try{store?.removeItem(key);store?.removeItem(startKey)}catch{}
 return;
}
if(on){try{store?.setItem(key,'1')}catch{}}
let persisted=false;
try{persisted=store?.getItem(key)==='1'}catch{}
if(!on&&!persisted)return;
if(/^\/(?:cart|checkout|account)(?:\/|$)/.test(location.pathname)||location.pathname.includes('/apps/'))return;
document.documentElement.dataset.fcfs04Active='true';
const current=Date.now();
let started=NaN;
try{started=Number(store?.getItem(startKey))}catch{}
if(!Number.isFinite(started)||started<=0||started>current)started=current;
try{store?.setItem(startKey,String(started))}catch{}
const money=c=>new Intl.NumberFormat('it-IT',{minimumFractionDigits:2,maximumFractionDigits:2}).format(c/100)+'€';
const steps=18,stepMs=6000,round=n=>Math.round(n/5)*5;
const amount=(final,step)=>{
 const start=round(final*.73);
 return Math.max(0,Math.min(final,round(start+(final-start)*Math.min(steps,step)/steps)));
};
const mark=[
 '<div class="fcfs04-demo__top"><span class="fcfs04-demo__mode"><i aria-hidden="true"></i>FCFS / DEMO</span><span class="fcfs04-demo__count">0 SIMULATED CONFIRMATIONS</span></div>',
 '<div class="fcfs04-demo__value">—</div>',
 '<div class="fcfs04-demo__track" aria-hidden="true"><i></i></div>',
 '<div class="fcfs04-demo__foot"><span class="fcfs04-demo__start">START —</span><span class="fcfs04-demo__end">FINAL —</span></div>',
 '<div class="fcfs04-demo__notice">SIMULATED PRICE · SHOPIFY CHECKOUT UNCHANGED</div>'
].join('');
const widgets=new Set();
function paint(el,count){
 const final=Number(el.dataset.base);
 if(!Number.isSafeInteger(final)||final<=0)return;
 const value=money(amount(final,count)),target=el.querySelector('.fcfs04-demo__value');
 if(target.textContent!==value){
  const prior=target.textContent;
  target.textContent=value;
  if(prior!=='—'){
   target.classList.remove('fcfs04-demo__value--changed');
   void target.offsetWidth;
   target.classList.add('fcfs04-demo__value--changed');
  }
 }
 el.querySelector('.fcfs04-demo__start').textContent='START '+money(round(final*.73));
 el.querySelector('.fcfs04-demo__end').textContent='FINAL '+money(final);
 el.querySelector('.fcfs04-demo__count').textContent=count+' SIMULATED CONFIRMATIONS';
 el.querySelector('.fcfs04-demo__track i').style.width=(count/steps*100)+'%';
}
function attach(host,base,type){
 if(host.dataset.fcfs04Widget==='true'||!Number.isSafeInteger(base)||base<=0)return;
 let anchor=type==='pdp'?host.querySelector('product-price'):
            type==='carousel'?host.querySelector('.nd-pc__price'):
            type==='grid'?host.querySelector('.pg-cap__price'):
            host.querySelector('.product-card__content');
 if(!anchor)return;
 const node=document.createElement('div');
 node.className='fcfs04-demo fcfs04-demo--'+type;
 node.setAttribute('data-fcfs04-demo-widget','');
 node.setAttribute('aria-label','Simulated FCFS price, not the purchase price');
 node.dataset.base=String(base);
 node.innerHTML=mark;
 if(type==='card')anchor.append(node);
 else anchor.insertAdjacentElement('afterend',node);
 host.dataset.fcfs04Widget='true';
 widgets.add(node);
 paint(node,Math.min(steps,Math.floor((Date.now()-started)/stepMs)));
}
function scan(){
 if(document.querySelector('[data-event-shop-04]'))return; // Room uses native event FCFS demo.
 document.querySelectorAll('.nd-pc__item[data-fcfs04-cents]').forEach(e=>attach(e,Number(e.dataset.fcfs04Cents),'carousel'));
 document.querySelectorAll('.pg-card[data-fcfs04-cents]').forEach(e=>attach(e,Number(e.dataset.fcfs04Cents),'grid'));
 document.querySelectorAll('product-card[data-fcfs04-cents]').forEach(e=>attach(e,Number(e.dataset.fcfs04Cents),'card'));
 if(document.body.classList.contains('template-product')){
  const details=document.querySelector('.product-details');
  if(details)attach(details,Number(document.body.dataset.fcfs04Cents),'pdp');
 }
}
let previousStep=-1;
function tick(){
 const step=Math.max(0,Math.min(steps,Math.floor((Date.now()-started)/stepMs)));
 if(step===previousStep)return;
 previousStep=step;
 for(const widget of [...widgets]){
  if(!widget.isConnected){widgets.delete(widget);continue}
  paint(widget,step);
 }
 const home=document.querySelector('[data-fcfs04-home-count]');
 if(home){home.hidden=false;home.textContent='ALL PRODUCTS / FCFS DEMO · '+step+' SIMULATED CONFIRMATIONS'}
}
function keepDemoOnNavigation(event){
 const link=event.target.closest?.('a[href]');
 if(!link||link.hasAttribute('download')||link.target==='_blank')return;
 const href=link.getAttribute('href');
 if(!href||href[0]==='#'||/^(?:mailto:|tel:|javascript:)/i.test(href))return;
 let next;try{next=new URL(href,location.origin)}catch{return}
 if(next.origin!==location.origin)return;
 if(/^\/(?:cart|checkout|account)(?:\/|$)/.test(next.pathname)||next.pathname.startsWith('/apps/'))return;
 const theme=qp.get('preview_theme_id');
 if(theme&&!next.searchParams.has('preview_theme_id'))next.searchParams.set('preview_theme_id',theme);
 next.searchParams.set('fcfs04','1');
 if(next.pathname==='/pages/black-friday-demo'||next.pathname.includes('waiting-room'))next.searchParams.set('sim','1');
 link.setAttribute('href',next.pathname+next.search+next.hash);
}
document.addEventListener('click',keepDemoOnNavigation,true);
const init=()=>{
 scan();tick();
 let pending=false;
 const observer=new MutationObserver(changes=>{
  if(pending)return;
  if(!changes.some(item=>[...item.addedNodes].some(node=>node.nodeType===1&&!node.matches?.('[data-fcfs04-demo-widget]'))))return;
  pending=true;
  setTimeout(()=>{pending=false;scan()},280);
 });
 observer.observe(document.body,{subtree:true,childList:true});
 const interval=setInterval(()=>{scan();tick()},1000);
 window.addEventListener('pagehide',()=>{clearInterval(interval);observer.disconnect()},{once:true});
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
else init();
})();